// extracted by mini-css-extract-plugin
export default {"root":"ESinlq","mobile":"Stajyl","fluid":"Cy0lsq"};